/* eslint-disable prettier/prettier */
/* eslint-disable react/no-danger */
import styled from 'styled-components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { X } from '../../Constants/assets';
// Stylings

const InnerContainer = styled.div`
    width: 850px;
    height: 408px;
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: center;
    font-family: 'Roboto', sans-serif;
    z-index: 3;
    animation: zoomIn 0.2s ease-in-out;
    position: fixed;
`;
const TextContainer = styled.div`
    height: 70%;
    margin-top: -20px;
`;
const XContainer = styled(X)``;
const Br = styled.div`
    height: 15%;
`;
const HeaderContainer = styled.div`
    width: 85%;
    height: 22%;
    margin: 0 auto;
`;
const HeaderText = styled.div`
    font-weight: bold;
    font-size: 24px;
    line-height: 100%;
    color: ${props => props.theme.colors.black};
    height: 95%;
    text-align: center;
`;
const ParagraphText = styled.div`
    font-size: 16px;
    line-height: 135%;
    color: ${props => props.theme.colors.black};
    width: 80%;
    display: inline-table;
    text-align: center;
`;

const ButtonContainer = styled.button`
    width: 216px;
    height: 50px;
    background: ${props => props.theme.colors.darkGreen};
    border-radius: 4px;
    cursor: pointer;
    border: none;
`;
const ButtonContainerLine = styled.div`
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: center;
`;
const GetStartedButton = styled.div`
    font-weight: bold;
    font-size: 16px;
    line-height: 2.05vh;
    color: ${props => props.theme.colors.white};
    width: 100%;
`;
// export const checkedbegin = beginCheckboxChecked;
// TODO: Fix this, this is temporary fix
export default function PlanYourProjectPopUp({
    show,
    togglePlanYourProjectPopUp,
    toggleShow,
    toggleModal,
    setPressedOkGotIt,
}) {
    const { t } = useTranslation();
    if (show) {
        return (
            <InnerContainer>
                <Br />
                <TextContainer>
                    <HeaderContainer>
                        <HeaderText>{t('modals.plan_your_project.info_title')}</HeaderText>
                    </HeaderContainer>
                    <ParagraphText>
                        <p dangerouslySetInnerHTML={{__html: t('modals.plan_your_project.info_text').replace(/\n/g, '<br/>')}}/>
                    </ParagraphText>
                </TextContainer>
                <ButtonContainerLine>
                    <ButtonContainer
                        onClick={() => {
                            togglePlanYourProjectPopUp(false);
                            toggleShow();
                            toggleModal(false);
                            setPressedOkGotIt(true);
                        }}
                    >
                        <GetStartedButton>{t('modals.plan_your_project.button1')}</GetStartedButton>
                    </ButtonContainer>
                </ButtonContainerLine>
            </InnerContainer>
        );
    }
    return null;
}
